module.exports = __webpack_public_path__ + "media/images/home/expand-4994eb0fe76b8e5bb84f380656ea2933.svg";